// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  CustomerListResponse,
  CustomerQueryParams,
} from "utils/api/client/types"

interface Client {
  fetch(
    url: string,
    options: {
      method?: string
      headers?: Record<string, string>
      body?: any
      query?: Record<string, any>
    }
  ): Promise<any>
}

interface CustomerDetails {
  email?: string
  first_name?: string
  // Add other customer fields as needed
}

interface QueryParams {
  limit?: number
  offset?: number
  fields?: string
  // Add other query parameters as needed
}

class Customer {
  private client: unknown

  /**
   * @ignore
   */
  constructor(client: unknown) {
    this.client = client
  }

  async list(
    vendorId: string,
    queryParams?: QueryParams,
    headers?: Record<string, string>
  ): Promise<CustomerListResponse> {
    return (this.client as any).fetch(`/vendor/${vendorId}/customer`, {
      headers,
      query: queryParams,
    })
  }

  delete(
    id: string,
    vendorId: string,
    headers?: Record<string, unknown>
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/customer/${id}`,
        {
          method: "DELETE",
          headers,
        }
      )
    })()
  }

  addUserToVendor(
    body: { vendorId: string; customerIds: string[]; userIds?: string[] },
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<any> {
    return (async () => {
      return await (this.client as any).fetch(
        `vendor/${body.vendorId}/customer-user/add-user`,
        {
          method: "POST",
          headers,
          body,
          query,
        }
      )
    })()
  }

  addCustomerToVendor(
    body: { vendorId: string; customerIds: string[]; userIds?: string[] },
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<any> {
    return (async () => {
      return await (this.client as any).fetch(
        `vendor/${body.vendorId}/vendor-customer/add-customer`,
        {
          method: "POST",
          headers,
          body,
          query,
        }
      )
    })()
  }

  removeCustomer(
    body: { vendorId: string; customerIds: string[]; userIds?: string[] },
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<any> {
    return (async () => {
      return await (this.client as any).fetch(
        `vendor/${body.vendorId}/customer-user/remove-user`,
        {
          method: "POST",
          headers,
          body,
          query,
        }
      )
    })()
  }

  async retrieve(
    query?: CustomerQueryParams,
    headers?: unknown
  ): Promise<CustomerListResponse> {
    return (this.client as any).fetch(`/vendor/customer`, {
      query,
      headers,
    })
  }

  async listByGroupId(
    vendorId: string,
    query?: CustomerQueryParams,
    headers?: unknown
  ): Promise<CustomerListResponse> {
    return (this.client as any).fetch(`/vendor/${vendorId}/customer`, {
      query,
      headers,
    })
  }
}

export { Customer }
